import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const getSummary = createAsyncThunk("GET_SUMMARY_API", async () => {
  let raw = JSON.stringify({});
  let config = {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("token"),
      "Content-Type": "application/json",
    },
  };

  try {
    const response = await axios.post(
      `${API_BASE_URL}/summary/summary`,
      raw,
      config
    );
    let status = "success";
    let data_res = {
      status: status,
      message: response,
    };
    return data_res;
  } catch (error) {
    let status = "error";
    let data_error = {
      status: status,
      message:
        error.response?.data || "Something went wrong, please try again.",
    };
    return data_error;
  }
});

const SummarySlice = createSlice({
  name: "GET_SUMMARY_SLICE",
  initialState: {
    loading: false,
    error: null,
    data: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getSummary.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getSummary.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.status === "success") {
          state.data = action.payload.message.data;
          state.error = null; // Clear any previous errors
        } else {
          state.error = action.payload.message || "Failed to fetch summary data";
        }
      })
      .addCase(getSummary.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default SummarySlice.reducer;
